module.exports = __webpack_public_path__ + "img/delete.7363895d.svg";